import React from "react";
import { Router, Route, Link, Switch, Redirect } from "react-router-dom";
import { createBrowserHistory } from "history";
import { getAuthorization, config, logout } from '../global/models/account';
import { adminPagesMenu } from '../global/global-props';
import { withTranslation } from 'react-i18next';

import './App.scss';
import RoomTiles from "./RoomTiles";
import {logoImageAltText, localProps, siteSettings} from './local-props'

import RoomView from "../global/views/room";
import ReceptionistView from "../global/views/receptionist";
import ReceptionistMapView from "../global/views/receptionist/map";
import ReceptionistReservationsView from "../global/views/receptionist/reservations";
import ReceptionistCheckInView from "../global/views/receptionist/checkin";
import ReceptionistAdvancedReservationView from "../global/views/receptionist/reservation";
import ReceptionistDevicesView from "../global/views/receptionist/devices";
import ReceptionistPaymentView from "../global/views/receptionist/payment";
import ReceptionistHeader from "../global/views/receptionist/partials/header";
import AttendantMapView from "../global/views/attendant/map";
import AttendantSectionMapView from "../global/views/attendant/section-map";
import AttendantAllTasks from "../global/views/attendant/all-tasks";
import Login from "../global/views/Login";
import WaitingRoomView from "../global/views/waitingroom";
import KioskView from "../global/views/kiosk";
import MikvahView from "../global/views/mikvah";
import AttendantTabletView from "../global/views/attendant/tablet";
import CleanerView from "../global/views/cleaner";
import ManagerView from "../global/views/manager";
import UsageReport from "../global/views/manager/usageReport";
import ExitView from "../global/views/exit";
import LobbyView from "../global/views/lobby";
import SalonView from "../global/views/salon";
import Button from "../global/components/button";
import { SettingsProvider } from '../global/components/settings';
import ReceptionistUserView from "../global/views/receptionist/user";
import CubicleView from "../global/views/cubicle";
import EditTranslations from "../global/views/translations/translations";

import ReceptionAttendantTasksView from '../global/views/receptionist/attendantTasks';

import logo from './images/MikvahLogo.png';
import logoWhite from './images/MikvahLogoWhite.png';

const history = createBrowserHistory();

const AppRouter = () => (
  <Router history={history}>
    <Switch>
      <PrivateRoute path="/" exact component={Index} />
      <Route path="/login" component={({location}) => <Login location={location} logo={logo} logoImageAltText={logoImageAltText} />} />
      <PrivateRoute path="/translations/" usernames={['translator@spotlightdesign.com']} component={EditTranslations} />

      <PrivateRoute path="/receptionist/map" usernames={['Reception']} render={() => <ReceptionistWideScreenMapView><ReceptionistMapView roomTiles={RoomTiles} siteSettings={siteSettings}/></ReceptionistWideScreenMapView>} />
      <PrivateRoute path="/receptionist/reservations/kallah" usernames={['Reception']} render={() => <ReceptionistWideScreenMapView><ReceptionistReservationsView key="1" kallah={true} localProps={localProps} siteSettings={siteSettings}/></ReceptionistWideScreenMapView> } />
      <PrivateRoute path="/receptionist/reservations" usernames={['Reception']} render={() => <ReceptionistWideScreenMapView><ReceptionistReservationsView localProps={localProps} siteSettings={siteSettings}  key="2"/></ReceptionistWideScreenMapView> } />
      <PrivateRoute path="/receptionist/checkin" usernames={['Reception']} render={({location}) => <ReceptionistWideScreenMapView><ReceptionistCheckInView localProps={localProps} siteSettings={siteSettings} reservation={location.state&&location.state.reservation?location.state.reservation:null} userId={location.state&&location.state.userId?location.state.userId:null} walkin={location.state&&location.state.walkin?location.state.walkin:false}/></ReceptionistWideScreenMapView>} />
      <PrivateRoute path="/receptionist/reservation/:id" usernames={['Reception']} render={({match}) => <ReceptionistWideScreenMapView><ReceptionistAdvancedReservationView key="1" localProps={localProps} siteSettings={siteSettings} id={match.params.id} /></ReceptionistWideScreenMapView>} />
      <PrivateRoute path="/receptionist/reservation" usernames={['Reception']} render={({location}) => <ReceptionistWideScreenMapView><ReceptionistAdvancedReservationView key="2" localProps={localProps} siteSettings={siteSettings} reservation={location.state&&location.state.reservation?location.state.reservation:null} kallah={location.state&&location.state.kallah} isEditingReservation={location.state&&location.state.isEditingReservation?location.state.isEditingReservation:null} userId={location.state&&location.state.userId?location.state.userId:null} /></ReceptionistWideScreenMapView>} />
      <PrivateRoute path="/receptionist/devices" usernames={['Reception']} render={({location}) => <ReceptionistWideScreenMapView><ReceptionistDevicesView siteSettings={siteSettings} /></ReceptionistWideScreenMapView>} />
      <PrivateRoute path="/receptionist/payment" usernames={['Reception']} render={({location}) => <ReceptionistWideScreenMapView><ReceptionistPaymentView localProps={localProps} siteSettings={siteSettings} userId={location.state&&location.state.userId?location.state.userId:null} /></ReceptionistWideScreenMapView>} />
      <PrivateRoute path="/receptionist/user/:id" usernames={['Reception']} render={(props) => <ReceptionistWideScreenMapView><ReceptionistUserView localProps={localProps} siteSettings={siteSettings} userId={props.match.params.id} {...props} key="1" /></ReceptionistWideScreenMapView>} />
      <PrivateRoute path="/receptionist/user" usernames={['Reception']} render={(props) => <ReceptionistWideScreenMapView><ReceptionistUserView localProps={localProps} siteSettings={siteSettings} userId={props.location.state&&props.location.state.userId?props.location.state.userId:null} {...props} key="2" /></ReceptionistWideScreenMapView>} />
      <PrivateRoute path="/receptionist/dashboard" usernames={['Reception']} render={() => <ReceptionistWideScreenMapView><ReceptionistView localProps={localProps} siteSettings={siteSettings}/></ReceptionistWideScreenMapView>} />
      <PrivateRoute path="/receptionist/" usernames={['Reception']} render={() => <Redirect to="/receptionist/dashboard/" />} />

      <PrivateRoute path="/attendant/tablet/" usernames={['Attendant']} component={() => <AttendantTabletView logo={logo} logoWhite={logoWhite} logoImageAltText={logoImageAltText}/>} />
      <PrivateRoute path="/attendant/map/" usernames={['Attendant']} component={() => <AttendantMapView roomTiles={RoomTiles} siteSettings={siteSettings}/>} />
      <PrivateRoute path="/attendant/alltasks/" usernames={['Attendant']} component={() => <AttendantAllTasks logo={logo} logoImageAltText={logoImageAltText} siteSettings={siteSettings}/>} />
      <PrivateRoute path="/attendant/sectionmap/:id" usernames={['Attendant']} component={({match}) => <AttendantSectionMapView logoWhite={logoWhite} logo={logo} roomTiles={RoomTiles} logoImageAltText={logoImageAltText} id={match.params.id} />} />
      <PrivateRoute path="/attendant/sectionmap/" usernames={['Attendant']} component={() => <AttendantSectionMapView logoWhite={logoWhite} logo={logo} roomTiles={RoomTiles} logoImageAltText={logoImageAltText}/>} />
      <PrivateRoute path="/attendant/" usernames={['Attendant']} component={Attendant} />
      
      <PrivateRoute path="/room/:id/" usernames={['Room', 'Reception', 'Attendant']} component={({match}) => <RoomView logoWhite={logoWhite} logo={logo} localProps={localProps} siteSettings={siteSettings} logoImageAltText={logoImageAltText} id={match.params.id} />} />
      <PrivateRoute path="/room/" usernames={['Room']} component={() => <RoomView logoWhite={logoWhite} logo={logo} localProps={localProps} siteSettings={siteSettings} logoImageAltText={logoImageAltText}/>} />

      <PrivateRoute path="/waiting/" usernames={['Waiting']} component={() => <WaitingRoomView logo={logo} logoWhite={logoWhite} logoImageAltText={logoImageAltText}/>} />

      <PrivateRoute path="/cubicle/:id" usernames={['Waiting']} component={({match}) => <CubicleView logo={logo} logoWhite={logoWhite} logoImageAltText={logoImageAltText} id={match.params.id} />} />
      <PrivateRoute path="/cubicle/" usernames={['Waiting']} component={() => <CubicleView logo={logo} />} />
      
      <PrivateRoute path="/kiosk/:id/" usernames={['Kiosk']} component={({match}) => <KioskView logo={logo} logoWhite={logoWhite} logoImageAltText={logoImageAltText} localProps={localProps} siteSettings={siteSettings} id={match.params.id} />} />
      <PrivateRoute path="/kiosk/" usernames={['Kiosk']} component={() => <KioskView logo={logo} logoWhite={logoWhite} logoImageAltText={logoImageAltText} localProps={localProps} siteSettings={siteSettings}/>} />
      
      <PrivateRoute path="/mikvah/:id/" usernames={['Mikvah']} component={({match}) => <MikvahView logoWhite={logoWhite} logo={logo} logoImageAltText={logoImageAltText} id={match.params.id} />} />
      <PrivateRoute path="/mikvah/" usernames={['Mikvah']} component={() => <MikvahView logoWhite={logoWhite} logo={logo} logoImageAltText={logoImageAltText}/>} />
      
      <PrivateRoute path="/cleaner/" usernames={['Cleaner']} component={() => <CleanerView logoWhite={logoWhite} logo={logo} logoImageAltText={logoImageAltText} siteSettings={siteSettings}/>} />
      
      <PrivateRoute path="/manager/reservations/report" component={(props) => <ReceptionistWideScreenMapView><UsageReport {...props} siteSettings={siteSettings} /></ReceptionistWideScreenMapView>} />
      <PrivateRoute path="/manager/schedule" component={() => <ReceptionistWideScreenMapView><ManagerView route="Schedule" siteSettings={siteSettings} /></ReceptionistWideScreenMapView>} />
      <PrivateRoute path="/manager/settings" component={() => <ReceptionistWideScreenMapView><ManagerView route="Settings" siteSettings={siteSettings} /></ReceptionistWideScreenMapView>} />
      <PrivateRoute path="/manager/advanced" component={() => <ReceptionistWideScreenMapView><ManagerView route="SettingsAdvanced" siteSettings={siteSettings}/></ReceptionistWideScreenMapView>} />
      <PrivateRoute path="/manager/attendants" usernames={['Reception']} component={() => <ReceptionistWideScreenMapView><ManagerView route="Attendants" siteSettings={siteSettings}/></ReceptionistWideScreenMapView>} />
      <PrivateRoute path="/manager/users" component={() => <ReceptionistWideScreenMapView><ManagerView route="AdminUsers" siteSettings={siteSettings}/></ReceptionistWideScreenMapView>} />
      <PrivateRoute path="/manager/audio" component={() => <ReceptionistWideScreenMapView><ManagerView route="Audio" siteSettings={siteSettings}/></ReceptionistWideScreenMapView>} />
      <PrivateRoute path="/manager/dashboard" usernames={['Reception']} component={() => <ReceptionistWideScreenMapView><ManagerView route="ManagerDash" localProps={localProps} siteSettings={siteSettings}/></ReceptionistWideScreenMapView>} />
      <PrivateRoute path="/manager/" component={() => <Redirect to="/manager/dashboard/" />} />
      
      <PrivateRoute path="/exit/" usernames={['ExitScreen']} component={() => <ExitView logo={logo} logoImageAltText={logoImageAltText} />} />
      <PrivateRoute path="/lobby/" usernames={['LobbyScreen']} component={() => <LobbyView logo={logo} logoImageAltText={logoImageAltText} />} />
      
      <PrivateRoute path="/salon/" usernames={['Salon']} component={() => <SalonView />} />
      
    </Switch>
  </Router>
);

config.onLogout = () => {
  appAuth.signout();
  history.push('/');
  /*withRouter(
    ({ history }) => console.log(history)
  );*/
  //this.props.history.push("/login");
};


export const appAuth = {
  authorization: null,
  isAuthenticated() {
    return this.authorization != null
  },
  checkAuthorization(cb) {
    let authorization = getAuthorization();
    if ( authorization && authorization.refreshToken !== null ) {
      this.authorization = authorization;
    } else {
      this.authorization = null;
    }
    setTimeout(cb, 100);
  },
  signout(cb) {
    this.authorization = null;
    setTimeout(cb, 100);
  }
};

function PrivateRoute({ component: Component, render: Render, ...rest }) {
  appAuth.checkAuthorization();
  return (
    <SettingsProvider>
      <Route
        {...rest}
        render={props =>
          appAuth.isAuthenticated() ? (
            //If Admin role OR allowed username
            appAuth.authorization.roles.includes('"Admin"') || (typeof(rest.usernames)!=='undefined'?rest.usernames.includes(appAuth.authorization.username):false) || props.location.pathname==='/' ? (
              Render ? (
                Render(props)
              ) : Component ? (
                  <Component {...props} />
              ) : null
            ) : (
              <Redirect to={{ pathname: "/", }} />
            )
          ) : (
            <Redirect
              to={{
                pathname: "/login",
                state: { from: props.location }
              }}
            />
          )
        }
      />
    </SettingsProvider>
  );
}

const Index = withTranslation()((props) => {
  const { t } = props;
  appAuth.checkAuthorization();
  return <div className="container-page vh-100 d-flex align-items-center">
    <div className="container-body text-center">
      <nav>
        <ul className="list-unstyled">
          {adminPagesMenu.map((item,i) => {
            if (typeof(item.usernames)==='undefined' || (appAuth.isAuthenticated() && (appAuth.authorization.roles.includes('"Admin"') || item.usernames.includes(appAuth.authorization.username)))) {
              return <li key={i}>
                <Link to={item.link} className="btn btn-secondary btn-lg mb-3">{t(item.title)}</Link>
              </li>
            } else {
              return null;
            }
          })}
          <hr />
          {appAuth.isAuthenticated()?
            <li>
              <Button type="primary" onClick={logout}>{t("Logout")}</Button>
            </li>
          :
            <li>
              <Link to="/login/" className="btn btn-primary">{t("Login")}</Link>
            </li>
          }
        </ul>
      </nav>
    </div>
  </div>
})

const Attendant = withTranslation()((props) => {
  const { t } = props;
 return <div className="container-page vh-100 d-flex align-items-center">
  <div className="container-body text-center">
    <nav>
      <ul className="list-unstyled">
        <li>
          <Link to="/attendant/map/" className="btn btn-secondary btn-lg mb-3">{t("Map")}</Link>
        </li>
        {siteSettings.showSectionMap?
        <li>
          <Link to="/attendant/sectionmap/" className="btn btn-secondary btn-lg mb-3">{t("Section Map")}</Link>
        </li>
        :null}
        <li>
          <Link to="/attendant/alltasks/" className="btn btn-secondary btn-lg mb-3">{t("All Sections Tasks")}</Link>
        </li>
        <li>
          <Link to="/attendant/tablet/" className="btn btn-secondary btn-lg mb-3">{t("Tablet")}</Link>
        </li>
      </ul>
    </nav>
  </div>
</div>});

const ReceptionistWideScreenMapView = (props) => <div className="container-page">
  <ReceptionistHeader logo={logo} logoImageAltText={logoImageAltText}/>
  <div className="container-page container-page-widescreen align-items-center">
    {props.children}
    <div className="view-map-extension">
      <ReceptionistMapView roomTiles={RoomTiles} siteSettings={siteSettings} />
    </div>
    <ReceptionAttendantTasksView />
  </div>
</div>;

export default AppRouter;